import React, { ReactNode } from 'react';

import { twMerge } from 'tailwind-merge';

import Icon, { IconKey } from './Icon';

interface Props {
    description?: ReactNode;
    iconKey?: IconKey;
    className?: string;
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
    children: ReactNode;
}

const SettingsButton = ({
    description,
    iconKey,
    className,
    onClick,
    children,
}: Props) => (
    <button
        className={twMerge(
            'flex h-13 w-full items-center justify-between rounded-sm px-2 hover:bg-gray-100',
            className,
        )}
        onClick={onClick}
    >
        <div className="flex items-center gap-x-3">
            {iconKey ? <Icon iconKey={iconKey} /> : null}
            {children}
        </div>

        <div className="flex items-center gap-x-1">
            <div className="text-sm text-gray-500">{description}</div>
        </div>
    </button>
);

export default SettingsButton;
